import { FC } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';

const PartnerSlide: FC<any> = ({ slide, isMultiple }) => (
	<LocalizedLink href={`/success-stories/story/${slide.url}/`}>
		<LinkWrapper>
			<ImageWrapper>
				<StoryImage alt={slide?.story?.title} src={getImage(slide?.preview)} />
			</ImageWrapper>

			<StoryDetails className={isMultiple ? 'big-mobile-padding' : undefined}>
				<StoryTitle>{parseHTML(slide?.story?.title)}</StoryTitle>

				<StoryDescription>
					{parseHTML(slide?.story?.shortDescription)}
				</StoryDescription>
			</StoryDetails>
		</LinkWrapper>
	</LocalizedLink>
);

const LinkWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	align-items: center;
	gap: 16px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 18px;
	}
`;

const ImageWrapper = styled.div`
	width: 100%;
	aspect-ratio: 400/200;
	position: relative;
	overflow: hidden;
	border-radius: 32px;

	@media (max-width: 768px) {
		aspect-ratio: 345/160;
	}

	@media (min-width: 769px) {
		&:hover {
			img {
				transform: scale(1.08);
			}
		}
	}
`;

const StoryImage = styled.img`
	position: absolute;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
	top: 0;
	left: 0;
	transition: 0.3s;
`;

const StoryDetails = styled.div`
	display: flex;
	flex-direction: column;

	@media (max-width: 768px) {
		&.big-mobile-padding {
			padding: 0 60px;
		}
	}
`;

const StoryTitle = styled.h5`
	font-family: var(--font-sans);

	font-size: 28px;
	line-height: 35px;
	color: var(--color-purple);
	margin-bottom: 10px;

	@media (max-width: 768px) {
		margin-bottom: 4px;
		font-size: 22px;
		line-height: 30px;
	}
`;

const StoryDescription = styled.div`
	font-family: var(--font-sans);
	font-size: 18px;
	line-height: 25px;
	color: var(--color-purple-50);
	display: box;
	line-clamp: 3;
	box-orient: vertical;
	overflow: hidden;

	@media (max-width: 768px) {
		line-clamp: 2;
		font-size: 16px;
	}
`;

export default PartnerSlide;
